import { motion, AnimatePresence } from "framer-motion";
import React from "react";

export default function Drawer({ isOpen, onClose, children, width = 280 }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/60 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* Drawer */}
          <motion.div
            className="fixed top-0 left-0 z-50 h-full bg-[#363C55] shadow-xl"
            style={{ width }}
            initial={{ x: -width }}
            animate={{ x: 0 }}
            exit={{ x: -width }}
            transition={{ type: "tween", duration: 0.3 }}
          >
            <button
              onClick={onClose}
              className="text-white text-xl p-1 hover:bg-white/10 rounded transition-colors absolute right-4 top-3"
              aria-label="Close menu"
            >
              ✕
            </button>
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
